//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Marshall_info',
  data () {
    return {}
  },
  components: {},
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/ID/Marshall_info.vue